import React, { Component } from "react";
import { Route, NavLink, HashRouter } from "react-router-dom";

import Home from "./Home";
import SquadAssignments from "./SquadAssignments";
import SquadProduct from "./SquadProduct";
import SquadAgileMetrics from "./SquadAgileMetrics";
import SquadWorkCategory from "./SquadWorkCategory";
import SquadENPS from "./SquadENPS";
import SquadDataCleanup from "./SquadDataCleanup";
import SquadDataTimeliness from "./SquadDataTimeliness";
import NikeHighFives from "./NikeHighFives";
import KeyJiraFields from "./KeyJiraFields";
import GTLandscape from "./GTLandscape";
import ProdAnalytics from "./ProdAnalytics";


class SidePanel extends Component {
  render() {
    return (
      <HashRouter>
        <head>
          <base target="_blank" />
        </head>

        <body>
          <div class="container">
            <div class="sidebar">
              <div>
                <a href="" target="_self">
                  <img
                    id="logo-top"
                    src="Digital_Dash_sans_Nike.png"
                    alt="Nike Digital Dash"
                  />
                </a>
              </div>
              <h1>Squad</h1>
              <div class="NavLink">
                <NavLink to="/GTLandscape">Global Tech Landscape</NavLink><br />
                <NavLink to="/SquadAssignments">Assignments</NavLink><br />
                <NavLink to="/KeyJiraFields">Key Jira Fields</NavLink><br />
                <NavLink to="/SquadAgileMetrics">Agile Metrics</NavLink><br />
                <NavLink to="/SquadWorkCategory">Work Category</NavLink><br />
                <NavLink to="/SquadProduct">Product Catalog</NavLink><br />
                <NavLink to="/SquadENPS">eNPS</NavLink><br />
              </div>
              <h1>Data Quality</h1>
              <div class="NavLink">
                <NavLink to="/SquadDataTimeliness">Timeliness</NavLink><br />
                <NavLink to="/SquadDataCleanup">Exceptions</NavLink><br />
                <NavLink to="/ProdAnalytics">Site Analytics</NavLink><br />
              </div>
              <h1>Nike</h1>
              <div class="NavLink">
                <NavLink to="/NikeHighFives">High Fives</NavLink><br />
              </div>
              <h1>Resources</h1>
              <div class="NavLink">
                <a href="https://admin.dlv-enable-prod.nikecloud.com/">Squad Central</a><br />
                <a href="https://confluence.nike.com/display/DASH/Squad+Management">Request Form</a><br />
                <a href="https://confluence.nike.com/display/DASH/Data+Concierge+Intake">Data Concierge</a><br />
              </div>
              <br />
              
              <a href="https://nikedigital.slack.com/app_redirect?channel=digital-dash">
                <em className="fab fa-slack"></em>
              </a>
              <a href="https://confluence.nike.com/display/DASH/Digital+Dash">
                <em className="fab fa-confluence"></em>
              </a>
            </div>


            <Route exact path="/" component={Home} />
            <Route path="/SquadAssignments" component={SquadAssignments} />
            <Route path="/SquadProduct" component={SquadProduct} />
            <Route path="/SquadAgileMetrics" component={SquadAgileMetrics} />
            <Route path="/SquadWorkCategory" component={SquadWorkCategory} />
            <Route path="/SquadENPS" component={SquadENPS} />
            <Route path="/SquadDataCleanup" component={SquadDataCleanup} />
            <Route path="/SquadDataTimeliness" component={SquadDataTimeliness} />
            <Route path="/NikeHighFives" component={NikeHighFives} />
            <Route path="/KeyJiraFields" component={KeyJiraFields} />
            <Route path="/GTLandscape" component={GTLandscape} />
            <Route path="/ProdAnalytics" component={ProdAnalytics} />



          </div>
        </body>
      </HashRouter>
    );
  }
}
export default SidePanel;
